import { render, staticRenderFns } from "./Fanzone-roadtour.vue?vue&type=template&id=12f8700e&"
import script from "./Fanzone-roadtour.vue?vue&type=script&lang=js&"
export * from "./Fanzone-roadtour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports